import { Actor } from '../../../Actor';
import { catAssetConfig } from './CatConfig';

export class Cat extends Actor {
  constructor(scene, x, y, color, frame) {
    super(scene, x, y, catAssetConfig, catAssetConfig.NAME, frame);

    this.spriteName = this.ObjectData.NAME;
    this.Inventory = this.ObjectData.INVENTORY;
    this.Sounds = this.ObjectData.AUDIO;

    this.currentSpriteSheet = color;
    this.originalScale = this.ObjectData.SCALE;
  }
}
